import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { SessionTokenService } from '../../../../../session/service/session-token';
import { environment } from '../../../../../../environments/environment';
import { TimezoneStorage } from '../../../../../shared/misc/service/timezone-storage';

@Component({
  selector: 'admin-customer-campaign-list',
  templateUrl: './campaign.component.html',
  styleUrls: [ './campaign.component.scss' ]
})
export class AdminCustomerCampaignListComponent extends AbstractListComponent implements OnInit {

  getResourceUrl(): string {
    return `/admin/campaign?customer=${this.route.parent.snapshot.params.id}`;
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              private sessionToken: SessionTokenService,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Accounts / Campaigns',
      url: `/admin/customer/${this.route.parent.snapshot.params.id}/campaign`
    });

    this.parameters.limit = 100;
    this.parameters.conditions.customer = this.route.parent.snapshot.params.id;
    super.ngOnInit();
  }

  open(campaign) {
    this.httpClient.post(`/admin/customer/${this.route.parent.snapshot.params.id}/campaign/${campaign.uuid}/login`, {})
      .subscribe(
        (sessionData: any) => {
          localStorage.setItem('adminTimezone', TimezoneStorage.get());
          TimezoneStorage.store(sessionData.timezone);
          this.sessionToken.storeAdminToken(this.sessionToken.getToken());
          this.sessionToken.persist(sessionData);

          this.router.navigate([ `/campaign/${campaign.uuid}` ]);
        }
      );
  }

  editRow(row) {
    if (row.__editing) {
      row.__editing = false;
      return;
    }
    this.httpClient.get<any>(`/admin/campaign/${row.uuid}`).subscribe((fullRow) => {
      Object.assign(row, fullRow);
      row.__editing = true;
    });
  }

  get rootDomain(): string {
    return environment.linkpage.rootDomain;
  }
}
